import { useSyncExternalStore } from 'react'
const KEY = 'relaii:external-images:v1'
const EVENT = 'relaii:external-images-changed'

function allowed(): boolean {
  try { return window.localStorage.getItem(KEY) === 'allow' } catch { return false }
}
function subscribe(listener: () => void): () => void {
  window.addEventListener('storage', listener)
  window.addEventListener(EVENT, listener)
  return () => { window.removeEventListener('storage', listener); window.removeEventListener(EVENT, listener) }
}
export function useExternalImages(): boolean { return useSyncExternalStore(subscribe, allowed, () => false) }
export function setExternalImages(allow: boolean): void {
  try { window.localStorage.setItem(KEY, allow ? 'allow' : 'ask') } catch { /* Keep the safer default. */ }
  window.dispatchEvent(new Event(EVENT))
}

/** True for an absolute URL that would be fetched from somewhere other than this Space. */
export function isExternalUrl(value: string): boolean {
  try {
    return new URL(value, window.location.href).origin !== window.location.origin
  } catch {
    return true
  }
}

/**
 * The avatar to draw for a message.
 *
 * A webhook may name an avatar of its own, and whoever holds the webhook's
 * secret chooses the address — so loading it tells that address which readers
 * opened the room, and when. It is treated like a webhook image block: the
 * initials stand in until the reader has allowed external images on this
 * device. A sender's own profile image is served by this Space and never
 * needs asking.
 */
export function senderAvatarSrc(
  message: { sender_avatar_url?: string | null; sender: { avatar_url: string | null } },
  allowExternal: boolean,
): string | null {
  const override = message.sender_avatar_url
  if (override === undefined || override === null || override === '') return message.sender.avatar_url
  if (allowExternal || !isExternalUrl(override)) return override
  return null
}
